import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { IMyDpOptions } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DateService } from "src/app/date.service";
import { GlobalComponent } from "src/app/global/global.component";
import { AdminTimeEventEmitterBo } from "../admin-time.modal";
import { CommonApiService } from "src/app/commonapiservice";
import { groupList } from "../../claims/claims.model";
@Component({
  selector: "app-admin-time-edit",
  templateUrl: "./admin-time-edit.component.html",
  styleUrls: ["./admin-time-edit.component.scss"],
})
export class AdminTimeEditComponent implements OnInit {
  @Input() EditATInputProperty: AdminTimeEventEmitterBo =
    new AdminTimeEventEmitterBo();
  @Output() EditOutputAT = new EventEmitter<AdminTimeEventEmitterBo>();
  private onDestroy$: Subject<void> = new Subject<void>();
  EditEmployeeId: string = "00000000-0000-0000-0000-000000000000";
  EditEntryTypeLid : string = "00000000-0000-0000-0000-000000000000";
  EditIn: any;
  EditOut: any;
  EditDate: any;
  enterdhr: number = 0;
  entermin: number = 0;
  AdminTimeId:string = "00000000-0000-0000-0000-000000000000";
  EditTotalHours: any;
  EditNotes: any;
  EditserviceId: string = "00000000-0000-0000-0000-000000000000";
  ATEditDetails: any = [];
  showerror: string = "";
  viewnotes : string;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1,
    },
    showClearDateBtn: true,
    editableDateField: true,
  };
  constructor(
    public toasterService: ToastrService,
    public dateservice: DateService,
    public global: GlobalComponent,
    public datePipe: DatePipe,
    public CommonAPI: CommonApiService,
  ) {}
  ngOnInit(): void {
    this.showerror = "";
  }
  // ....................................AddAtItems............................................................
  AddAtItems() {
    // For Employee
    let EmployeeDetails = this.EditATInputProperty.EmployeeDropDown?.filter(
      (Emp) => Emp.Key == this.EditEmployeeId
    )[0];
    let EntrytypeDetails = this.EditATInputProperty.EditEntryTypeList?.filter(
      (Emp) => Emp.id == this.EditEntryTypeLid
    )[0];
    let employeeName = EmployeeDetails.Value;
    let entryTypeName = EntrytypeDetails?.lovName;
    let values = {
      id: this.AdminTimeId,
      employeeId: this.EditEmployeeId,
      entryTypeLid: this.EditEntryTypeLid,
      employeeName: employeeName,
      entryTypeName:entryTypeName,
      date: this.EditDate,
      totalhours: this.EditTotalHours,
      inTime: this.EditIn,
      outTime: this.EditOut,
      notes: this.EditNotes,
      setIn:
        this.EditIn != null && this.EditIn != undefined && this.EditIn != ""
          ? new Date(this.EditDate + " " + this.EditIn)
          : this.global.getDateTimeString(new Date()).toString(),
      setOut:
        this.EditOut != null && this.EditOut != undefined && this.EditOut != ""
          ? new Date(this.EditDate + " " + this.EditOut)
          : this.global.getDateTimeString(new Date()).toString(),
    };
    var index=0;
    this.ATEditDetails.forEach((element) => {
      if (element.employeeId == values.employeeId) {
        if (
          new Date(element.date).getTime() == new Date(values.date).getTime()
        ) {
          var checkOverlapforEmployee =
            (values.outTime >= element.inTime &&
              values.inTime <= element.outTime) ||
            (values.inTime <= element.outTime &&
              values.outTime >= element.outTime) ||
            (values.inTime >= element.outTime &&
              values.outTime <= element.outTime);
          if (checkOverlapforEmployee == true && index==0) {
            this.toasterService.error("You've entered time that overlaps with an existing Employee");
            this.showerror = "existed";
            index++;
          }
        }
      }
    });
    if (this.showerror == "") {
      this.ATEditDetails.push(values);
      this.ClearFields();
    }
    this.showerror = "";
  }
  //...............................................HoursCalculation............................................................
  HoursCalculation() {
    let InTime =
      this.EditIn != null && this.EditIn != undefined && this.EditIn != ""
        ? new Date(this.EditDate + " " + this.EditIn)
        : this.global.getDateTimeString(new Date()).toString();
    let OutTime =
      this.EditOut != null && this.EditOut != undefined && this.EditOut != ""
        ? new Date(this.EditDate + " " + this.EditOut)
        : this.global.getDateTimeString(new Date()).toString();

    if (
      this.EditIn != null &&
      this.EditOut != null &&
      this.EditIn != "" &&
      this.EditOut != "" &&
      this.EditIn != undefined &&
      this.EditOut != undefined
    ) {
      if (new Date(InTime).getTime() <= new Date(OutTime).getTime()) {
        let inTime = new Date(InTime);
        let outTime = new Date(OutTime);
        let diff = (outTime.getTime() - inTime.getTime()) / 1000;
        let minutesDifference = Math.abs(Math.floor(diff / 60));
        let roundedMinutes = Math.round(minutesDifference / 15) * 15;
        this.EditTotalHours = roundedMinutes / 60;
      }
      if (OutTime != null && OutTime != undefined && OutTime != "") {
        if (new Date(InTime).getTime() > new Date(OutTime).getTime()) {
          this.EditOut = null;
          this.toasterService.error("end time should greater than start time");
          this.EditTotalHours = null;
          setTimeout(() => {
            this.toasterService.clear();
          }, 3000);
          return;
        }
      }
    } else {
      this.EditTotalHours = null;
    }
  }
  //...............................................ClearFields............................................................
  ClearFields() {
    this.EditIn = null;
    this.EditOut = null;
    this.EditTotalHours = null;
    this.EditDate = "";
    this.EditNotes = null;
  }
  // ....................................removeATList............................................................
  removeATList(Index) {
    this.ATEditDetails.splice(Index, 1);
    this.showerror = "";
  }
  // ....................................DateChanges............................................................
  DateChanges(event, type, name) {
    if (type == "inputchanged") {
      if (name == "Date") {
        let element = this.dateservice.inputFeildchange(event);
        if (element != undefined) {
          let values = this.dateservice.inputFeildchange(event);
          this.EditDate = values;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "Date") {
        let element = this.dateservice.Datechange(event);
        if (element != undefined) {
          let values = this.dateservice.Datechange(event);
          this.EditDate = values;
        }
      }
    }
  }
  // ....................................closeAT............................................................
  closeAT() {
    this.EditATInputProperty.isClose = false;
    this.EditATInputProperty.isCreate = false;
    this.EditOutputAT.emit(this.EditATInputProperty);
  }
  //........................................................promiseCallFunction.................................................
  promiseCallFunction() {
    this.saveAT()
      .then((data) => {})
      .catch((err) => {});
  }
  //........................................................saveAT.................................................
  saveAT() {
    let saveAdminTime = JSON.parse(JSON.stringify(this.ATEditDetails));
    saveAdminTime.forEach((save) => {
      {
        let InTime =
          save.inTime != null && save.inTime != undefined && save.inTime != ""
            ? new Date(save.date + " " + save.inTime)
            : this.global.getDateTimeString(new Date()).toString();
        let OutTime =
          save.outTime != null &&
          save.outTime != undefined &&
          save.outTime != ""
            ? new Date(save.date + " " + save.outTime)
            : this.global.getDateTimeString(new Date()).toString();
        save.inTime = this.datePipe.transform(InTime, "yyyy-MM-dd'T'HH:mm:ss");
        save.outTime = this.datePipe.transform(
          OutTime,
          "yyyy-MM-dd'T'HH:mm:ss"
        );
        save.date =
          save.date != null ? this.global.getDateTimeString(save.date) : null;
        save.employeeId =
          save.employeeId != null ? save.employeeId.toString() :  "00000000-0000-0000-0000-000000000000";
        save.employeeId =
          save.employeeId != null ? save.employeeId.toString() : "00000000-0000-0000-0000-000000000000";
        save.totalhours = parseFloat(save.totalhours);
      }
    });
    let url = "api/AdminTimeNonBillable/SaveAdminTime"
    return new Promise((resolve, reject) => {
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveAdminTime,url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            resolve(data);

            if (data?.errorList?.length > 0) {
              this.toasterService.error(data.errorList);
              setTimeout(() => {
                this.toasterService.clear();
              }, 8000);
              return;
            }
            this.toasterService.success("AdminTime created successfully");
            setTimeout(() => {}, 3000);
            this.closeAT();
          },
          (err: any) => {
            reject(err);
            this.toasterService.error(err, "Error"), 8000;
          }
        );
    });
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
